import HTTP from './http-request-handler'

const accountRecoveryService = {
  verifyEmail: function (params) {
    return HTTP.post('/accountRecovery/verifyEmail', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  validateEmailOtp: function (params) {
    return HTTP.post('/accountRecovery/validateEmailOtp', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  setPassword: function (params) {
    return HTTP.post('/accountRecovery/setPassword', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  setPasswordAfterExpired: function (params) {
    return HTTP.post('/passwordExpired/setPassword', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
}
export default accountRecoveryService
